const Environment = {
  Prod: 'prod',
  Stage: 'stage',
  Dev: 'dev',
  Local: 'local',
} as const;

type Environment = typeof Environment[keyof typeof Environment];

class EnvService {
  private _env!: Environment;
  private API_URL!: string;
  private USER_API_URL!: string;
  private AWS_URL!: string;

  get env(): Environment {
    return this._env;
  }

  get apiUrl(): string {
    return this.API_URL;
  }

  get apiUserUrl(): string {
    return this.USER_API_URL;
  }

  get apiAwsUrl(): string {
    return this.AWS_URL;
  }

  constructor() {
    this.init();
  }

  init(): void {
    this.setEnvVariables();
    this.onAppInit1();
  }

  onAppInit1(): () => Promise<boolean> {
    return () => {
      return new Promise((resolve) => {
        return setTimeout(() => resolve(true), 5000);
      });
    };
  }

  private setEnvVariables(): void {
    const hostname = window && window.location && window.location.hostname;

    if (/^.*localhost.*/.test(hostname)) {
      this._env = Environment.Local;
    } else if (/^md.visitly.io/.test(hostname) || /^d3byypbvj0daax.cloudfront.net/.test(hostname)) {
      this._env = Environment.Dev;
    } else if (/^ms.visitly.io/.test(hostname)) {
      this._env = Environment.Stage;
    } else if (/^m.visitly.io/.test(hostname)) {
      this._env = Environment.Prod;
    } else {
      console.warn(`Cannot find environment for host name ${hostname}`);
      this._env = Environment.Local;
    }
      
      this.API_URL = import.meta.env.VITE_API_URL;
      this.USER_API_URL = import.meta.env.VITE_API_URL + '/users';
      
  }

  getEnvShortCode(): string | null {
    let val = null;

    switch (this.env) {
      case Environment.Local:
        val = 'localhost';
        break;
      case Environment.Dev:
        val = 'md';
        break;
      case Environment.Stage:
        val = 'ms';
        break;
      case Environment.Prod:
        val = 'm';
        break;
      default:
        break;
    }
    return val;
  }
}

export const envService = new EnvService();
